import { createI18n } from 'vue-i18n'
import { enUK } from '@/locales'

type MessageSchema = typeof enUK

export const messages = {
    'en-UK': enUK,
}

const i18n = createI18n<[MessageSchema], 'en-UK'>({
    legacy: false,
    locale: 'en-UK',
    fallbackLocale: 'en-UK',
    missingWarn: false,
    fallbackWarn: false,
    messages,
})

export default i18n
